<template>
    <v-card >
      <v-container v-if="sumfurush_card">
        <v-card-title class="pa-0 mb-2">Остаток склад
          <v-divider class="mx-2" inset vertical></v-divider>

          <export-excel
          :data="filteredMolho"
          :worksheet="'Остаток склад '"
          :name="'Остаток склад'"
          :title="'Остаток склад'"
          :fields="json_fields"
          :auto-width="true"
          >
          <v-icon  color="success" >
              mdi-microsoft-excel
              </v-icon>
      </export-excel>


        </v-card-title>
        <v-row class="mb-2">


          <v-col cols="12" md="3">




            <v-autocomplete
            clearable
             item-color="primary"
             color="primary"
             hide-no-data
             hide-details
             multiple
             solo
             :items="valutaho"
             item-text="valuta"
             item-value="valuta"
             label="Валюта"
             @click:clear="get_vozvratho"
             v-model="filters.valuta" />
          </v-col>
          <v-col cols="12" md="4">

              <v-text-field
              color="primary"
              prepend-inner-icon="mdi-magnify"
              solo
              v-model="searching"
              label="Поиск"/>

          </v-col>

        </v-row>

        <v-data-table
        :headers="headers"
        :items="filteredMolho"
        :loading="loading"
        loading-text="Загрузка. Пожалуйста подождите"
          :footer-props="{
              'items-per-page-options': [ 7, 20, 50, 100],
              'items-per-page-text':'Строк на странице',
          }"
          no-data-text="Данные отсутствуют в таблице"
        class="elevation-1"
        :search="searching">




          <template slot="body.append">
              <tr>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title ">{{Number( sumField('summa_s')).toFixed(2) }}</th>
                  <th class="title "></th>
                  <th class="title "></th>

              </tr>
          </template>

        </v-data-table>
      </v-container>



      <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
     >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Закрыть
        </v-btn>
      </template>
     </v-snackbar>


    </v-card>



</template>

<script>
export default {

data: () => ({

  searching: "",
  search: "",
  loading: false,


  valutaho: [
    { valuta: "TJS", id_kurb: 1 },
    { valuta: "USD", id_kurb: 2 },
    { valuta: "RUB", id_kurb: 3 },
  ],

     date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,



filters: {

nom: "",
valuta: "",
firma: "",

},



headers: [
        {
          text: 'Код',
          align: 'start',
          value: 'kod',
        },

        { text: 'Наименовние', value: 'nom' },
        { text: 'Остаток склад', value: 'OST_S' },
        { text: 'Себестоимость', value: 'narkhi_a' },
        { text: 'Цена роз.', value: 'narkhi_f' },
        { text: 'Цена опт.', value: 'narkhi_opt' },
        { text: 'Сумма', value: 'summa_s' },
        { text: 'Валюта', value: 'valuta' },
        { text: 'Поставщик', value: 'firma' },

],

    json_fields: {

    'Код': 'kod',
    'Наименовние': 'nom' ,
    'Остаток магазин': 'OST_S' ,
    'Себестоимость': 'narkhi_a' ,
    'Цена роз.': 'narkhi_f' ,
    'Цена опт.': 'narkhi_opt' ,
    'Сумма': 'summa_s' ,
    'Валюта': 'valuta' ,
    'Поставщик': 'firma' ,

    },

snack: false,
    snackColor: '',
    snackText: '',

loading: false,

furush_card: false,
sumfurush_card: true,
firmaho: [],
molho:[],




}),

mounted(){

  this.get_vozvratho();

  this.get_firmaho();
},

methods: {

    get_firmaho(){
          this.loading = true;
        axios.get('/api/get_firmaho1',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.firmaho = response.data.firmaho;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения фирмы"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },
  sumField(key) {
  return  this.filteredMolho.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },



  get_vozvratho(){
    this.loading = true;
              axios.get('/api/get_molho_p',
                      {
                          headers: {
                              "Content-type": "application/json"
                          }
                      })
                      .then(response => {
                              if(response.data.status){
                                  this.loading = false;
                                  this.molho = response.data.molho;
                              }else{
                                  this.loading = false;
                                  this.snack = true
                                  this.snackColor = 'error'
                                  this.snackText = "Ошибка получения клиентов"
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                              }
                          })
                          .catch(error => {
                              this.loading = false;
                              this.snack = true
                              this.snackColor = 'error'
                              this.snackText = error.response.data.message;
                                  setTimeout(() => {
                                      this.snack = false;
                                  }, 2000);
                          });
                  },








},

computed: {

  filteredMolho() {
let filter = this.molho.filter((id_mol) => {
  for (const [key, filterValue] of Object.entries(this.filters)) {
    // if (!filterValue.length) continue;
    if (!filterValue.length && typeof filterValue !== "boolean") continue; // No filters selected -> show all products.
    if (typeof filterValue === "boolean" && !filterValue) continue; // exclude the checkbox value if not true/false

    let dropdownValue = id_mol[key];

    //If its an array
    if (typeof filterValue === "object") {
      //Single value (single dropdown value)
      if (typeof dropdownValue === "string") {
        if (
          filterValue.findIndex((val) => {
            return val === dropdownValue.trim();
          }) === -1
        )
          return false;
        //Multiple values (multiple dropdown values)
      } else if (typeof dropdownValue === "object") {
        for (const filterString of filterValue) {
          if (dropdownValue.indexOf(filterString) === -1) return false;
        }
      }

      //If its a boolean
    } else if (typeof filterValue === "boolean") {
      if (typeof dropdownValue === "string") {
        if (dropdownValue.length == 0 && filterValue) return false;
        if (dropdownValue.length > 0 && !filterValue) return false;
      } else if (filterValue != dropdownValue) return false;

      //If its a string
    } else if (typeof filterValue === "string") {
      if (typeof filterValue === "string") {
        if (!dropdownValue || dropdownValue.indexOf(filterValue) === -1)
          return false;
      }
    }
  }
  return true;
});
return filter;

},



}

}
</script>

<style  scoped>

</style>



